import flatpickr from 'next/javascripts/modules/flatpickr'

class DateRangeFilter

  constructor: (options) ->
    @options = options
    @_selectElements()
    @_bind()
    @$element.data('date-range-filter', @)

  _selectElements: ->
    @$element = $(@options.element)
    @$dateRangePickerField = @$element.find('.date-range-picker-field')

  _bind: ->
    @$element
      .on 'click', (e) =>
        e.preventDefault()
        @initPopover()

  initPopover: ->
    @popover = simple.popover
                pointTo: @$element
                content: @$element.next('.tpl-date-range-filter').html()
                position: 'bottom-center'
                cls: 'dropdown-list no-arrow scrollable'
                offset:
                  x: 0
                  y: -10

  destroyPopover: ->
    @popover.destroy()

  initPicker: ->
    @picker = flatpickr @$dateRangePickerField[0],
      animate: false
      mode: 'range'
      defaultDate: @$dateRangePickerField.data('value').split(',')
      onOpen: =>
        @$element.addClass('active')
      onClose: =>
        @$element.removeClass('active')
      onChange: (selectedDates, dateStr, instance) =>
        if selectedDates.length == 2
          @search
            startDate: moment(selectedDates[0]).format('YYYY-MM-DD'),
            endDate: moment(selectedDates[1]).format('YYYY-MM-DD')
          @destroyPicker()
    @picker.calendarContainer.classList.add 'date-range-filter-picker'

  destroyPicker: ->
    @picker.destroy()

  openPicker: ->
    @picker.open()

  closePicker: ->
    @picker.close()

  search: (query) ->
    url = simple.url()

    if query.type && query.type != 'custom'
      if query.type == 'all'
        delete url.search.date_range_type
      else
        url.search.date_range_type = query.type
      delete url.search.start_date
      delete url.search.end_date
    else if query.startDate && query.endDate
      url.search.date_range_type = 'custom'
      url.search.end_date = query.endDate
      url.search.start_date = query.startDate

    tower.stack.load url.toString('relative'),
      replace: true
      nocache: true

$ ->
  $('.date-range-filter').each (i, element) ->
    filter = new DateRangeFilter
               element: element

  tower.stack.on 'pageload', (e, $page, page) ->
    $page.find('.date-range-filter').each (i, element) ->
      filter = new DateRangeFilter
                 element: element

  $(document)
    .on 'click', '.selector-menu.date-range-menu .selector-option', (e) ->
      e.preventDefault()
      $option = $(e.currentTarget)
      $menu = $option.closest('.simple-popover')
      value = $option.data('value')
      popover = $menu.data('popover')
      filter = popover.pointTo.data('date-range-filter')

      if value == 'custom'
        filter.initPicker() unless filter.picker
        filter.destroyPopover()
        filter.openPicker()
      else
        filter.search(type: value)
